<template>
  <div class="top-nav-fixed">
    <div class="row d-flex align-items-center justify-content-between">
      <div class="col-lg-3 mt-2 d-none d-lg-block">
        <EntityNav />
      </div>

      <div class="col-2 d-lg-none d-sm-block">
        <i class="fa fa-bars" @click="openNav()"></i>
        <img
          src="@/assets/images/fmn-logo.png"
          style="height: 40px; margin-left: 5px; display: none"
        />
      </div>
      <EntityNav
        v-if="showMobileEntityNav"
        class="d-none d-md-block d-lg-none mobile-entity-nav"
      />

      <div class="col-lg-3 offset-lg- col-5">
        <div
          class="nav-search-area"
          style="height: 40px; width: 115%; left: -21px"
        >
          <div class="form-group" v-if="productPage">
            <input
              type="text"
              v-model="product_search"
              v-on:keyup="searchProduct()"
              class="form-control main_search"
              placeholder="Search for products..."
              style="height: 40px; background: #f2f2f2"
            />
            <i class="fa fa-search"></i>
          </div>
        </div>
      </div>

      <div class="col-lg-2 offset-lg-2 col-3">
        <a href="/cart" class="text-dark" style="position: relative; top: 5px">
          <span class="nav-in-cart-count">{{ cart_count }}</span>

          <svg
            class="cart_icon"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.3101 20.6877H10.3115C10.3127 20.6877 10.314 20.6875 10.3152 20.6875H27.3125C27.731 20.6875 28.0989 20.4099 28.2139 20.0076L31.9639 6.88257C32.0447 6.59961 31.988 6.29541 31.811 6.06055C31.6338 5.82568 31.3567 5.6875 31.0625 5.6875H8.14795L7.47778 2.67163C7.38233 2.24268 7.00195 1.9375 6.5625 1.9375H0.9375C0.419678 1.9375 0 2.35718 0 2.875C0 3.39282 0.419678 3.8125 0.9375 3.8125H5.81055C5.9292 4.34692 9.01758 18.2449 9.19531 19.0444C8.19898 19.4775 7.5 20.4709 7.5 21.625C7.5 23.1758 8.76172 24.4375 10.3125 24.4375H27.3125C27.8303 24.4375 28.25 24.0178 28.25 23.5C28.25 22.9822 27.8303 22.5625 27.3125 22.5625H10.3125C9.79566 22.5625 9.375 22.1418 9.375 21.625C9.375 21.1089 9.79419 20.689 10.3101 20.6877ZM29.8196 7.5625L26.6052 18.8125H11.0645L8.56445 7.5625H29.8196Z"
              fill="#14142B"
            />
            <path
              d="M9.375 27.25C9.375 28.8008 10.6367 30.0625 12.1875 30.0625C13.7383 30.0625 15 28.8008 15 27.25C15 25.6992 13.7383 24.4375 12.1875 24.4375C10.6367 24.4375 9.375 25.6992 9.375 27.25ZM12.1875 26.3125C12.7043 26.3125 13.125 26.7332 13.125 27.25C13.125 27.7668 12.7043 28.1875 12.1875 28.1875C11.6707 28.1875 11.25 27.7668 11.25 27.25C11.25 26.7332 11.6707 26.3125 12.1875 26.3125Z"
              fill="#14142B"
            />
            <path
              d="M22.625 27.25C22.625 28.8008 23.8867 30.0625 25.4375 30.0625C26.9883 30.0625 28.25 28.8008 28.25 27.25C28.25 25.6992 26.9883 24.4375 25.4375 24.4375C23.8867 24.4375 22.625 25.6992 22.625 27.25ZM25.4375 26.3125C25.9543 26.3125 26.375 26.7332 26.375 27.25C26.375 27.7668 25.9543 28.1875 25.4375 28.1875C24.9207 28.1875 24.5 27.7668 24.5 27.25C24.5 26.7332 24.9207 26.3125 25.4375 26.3125Z"
              fill="#14142B"
            />
          </svg>

          <span
            class="d-none d-sm-none d-lg-inline"
            style="font-size: 14px; top: 8px; font-weight: 600"
            >Cart</span
          >
        </a>

        <div
          class="dropdown d-none d-sm-none d-lg-block"
          style="right: 5px; position: absolute; top: 0px"
        >
          <div
            class="d-flex align-items-center"
            style="cursor: pointer"
            @click="isProfileDropdownOpen = !isProfileDropdownOpen"
          >
            <img
              src="@/assets/images/avata.svg"
              style="
                border-radius: 50%;
                margin-left: 30px;
                width: 40px;
                height: 40px;
              "
              alt="Profile"
            />
            <i
              :class="[
                'fa',
                isProfileDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down',
              ]"
              style=""
            />
          </div>

          <ul
            class="dropdown-menu"
            v-show="isProfileDropdownOpen"
            style="display: block; position: absolute; margin-left: -20px"
          >
            <li>
              <a class="dropdown-item" href="/home"
                ><i class="fa fa-th-large"></i> Dashboard</a
              >
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a class="dropdown-item" href="/mode-of-delivery"
                ><i class="fa fa-truck"></i> Change Mode of Delivery</a
              >
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a class="dropdown-item" href="/profile"
                ><i class="far fa-user"></i> View Profile</a
              >
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a class="dropdown-item" href="/"
                v-on:click="logout"
                ><i class="fa fa-sign-out-alt"></i> Logout</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EntityNav from "@/components/EntityNav.vue";
export default {
  name: "TopNav",
  components: {
    EntityNav,
  },
  data() {
    return {
      customer_name: "",
      productPage: false,
      product_search: "",
      username: "",
      showMobileEntityNav: false,
      isProfileDropdownOpen: false,
    };
  },
  computed: {
    cart_count() {
      return this.$store.getters.cart.length;
    },
  },

  methods: {
    openNav() {
      this.showMobileEntityNav = !this.showMobileEntityNav;
      this.$store.commit("set_sideNav", true);
    },
    searchProduct() {
      this.$emit("searchProduct", this.product_search);
    },
    logout(){
      this.logout();
    }
  },
  beforeMount() {
    this.customer_name = this.$store.getters.sub_acct_name;

    this.username = this.$store.getters.username;

    let current_page = this.$route.name;

    if (current_page == "Products") {
      this.productPage = true;
    }
  },
};
</script>
<style scoped>
.fa-bars {
  background: #f2f2f2;
  padding: 11px 12px;
  border-radius: 8px;
  color: #000;
  font-size: 16px;
}
</style>